import { useTheme } from '@mui/material/styles'

// { variant }: { variant?: string }

const useArtistCardStyles = () => {
  const { breakpoints } = useTheme()

  return {
    card: {
      border: '1px solid #EAEAEA',
      borderRadius: '2px',
      padding: '0.5rem',
      backgroundColor: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      cursor: 'pointer',
      gap: '1rem',
      minWidth: ' 343px',
      maxWidth: '24.75rem',
      '&:hover': {
        // backgroundColor: '#F8F8F8',
        border: '1px solid #EAEAEA',
        opacity: 0.9,
      },
    },
    artist: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      [breakpoints.up('md')]: {
        minHeight: '86px',
      },
    },
    avatar: {
      width: '64px',
      position: 'absolute',
      left: 'calc(50% - 40px)',
      top: '60%',
      background: ' white',
      padding: '2px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      [breakpoints.up('lg')]: {
        width: '80px',
      },
      img: {
        borderRadius: '50%',
        maxWidth: ' 62px',
      },
      span: {
        borderRadius: '50%',
      },
    },
    infoWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '0.5rem',
    },
    name: {
      fontSize: '1.375rem',
      //   minHeight: '42px',
      display: 'flex',
      alignItems: 'center',
      [breakpoints.up('md')]: {
        fontSize: '1.375rem',
        // minHeight: '58px',
      },
    },
    locationsContainer: { display: 'flex', gap: '4px' },
    location: {
      color: 'rgba(0, 0, 0, 0.6)',
      fontSize: '0.75rem',
      [breakpoints.up('lg')]: {
        fontSize: '0.875rem',
      },
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: { xs: '214px', lg: '250px' },
    },
    verticalDivider: {
      width: '100%',
      border: '1px solid #f3f3f3',
    },
    stylesWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      maxHeight: '32px',
      flexWrap: 'wrap',
      overflow: 'hidden',
      maxWidth: { xs: '319px', lg: '374px' },
    },
    style: { display: 'flex', alignItems: 'center', gap: '0.5rem' },
    artworks: { display: 'flex', gap: '4px' },
    artworkWrapper: {
      width: '100%',
      height: '100%',
      position: 'relative',
      img: { borderRadius: '2px', height: '125px' },
      minHeight: '125px',
    },
    buttonContainer: {
      width: ' 100%',
      button: {
        width: '100%',
      },
    },
  }
}

export default useArtistCardStyles
